var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94992 16.5267H2.64441V6.61014H5.94992V16.5267ZM4.29783 5.28794C3.38352 5.28794 2.64441 4.54684 2.64441 3.63452C2.64441 2.7222 3.38484 1.98242 4.29783 1.98242C5.20883 1.98242 5.94992 2.72352 5.94992 3.63452C5.94992 4.54684 5.20883 5.28794 4.29783 5.28794ZM17.8498 16.5267H14.6719V11.7006C14.6719 10.5497 14.65 9.06945 13.0198 9.06945C11.365 9.06945 11.1105 10.3229 11.1105 11.6173V16.5267H7.93323V6.60287H10.9836V7.95879H11.0265C11.451 7.17869 12.4882 6.35628 14.0352 6.35628C17.2548 6.35628 17.8498 8.41165 17.8498 11.0838V16.5267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3f6a55a46ae363089767cc68a582c94d.svg";
export { ForwardRef as ReactComponent };